import { render, staticRenderFns } from "./OrticCard.vue?vue&type=template&id=3a354d0b"
import script from "./OrticCard.vue?vue&type=script&lang=js"
export * from "./OrticCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports